import styles from "./EmptyCase.module.css";
import { formaters } from "vincent-utils";
import RdvStars from "./RdvStars.tsx";
import { type Dated, type Timed, Transforms } from "cadendar-shared";
import classNames from "classnames";
import { useDroppable } from "@dnd-kit/core";

interface EmptyCaseProps {
  rdv: Timed & Dated & { tag: "empty" } & { stars?: number };
  heightMultiplier: number;
  onCaseClick: (rdv: { tag: "empty" } & Timed & Dated) => void;
}

const EmptyCase = (props: EmptyCaseProps) => {
  const { rdv, heightMultiplier, onCaseClick } = props;

  const { setNodeRef } = useDroppable({ id: Transforms.rdvs.getUniqueId(rdv) });

  const style = {
    height: heightMultiplier * rdv.duration + "em",
    anchorName: `--${Transforms.rdvs.getUniqueId(rdv)}`,
  };

  const { stars } = rdv;

  const uniqueID = Transforms.rdvs.getUniqueId(rdv);
  const hmString = formaters.formatHourMinuteObjectForDisplay(rdv);
  const isZeroMinute = (hmString: string) => hmString.split(":")[1] === "00";

  const handleClick = () => {
    if (Transforms.rdvs.isFakeCase(rdv)) {
      //est-ce que ça ne devrait pas plutôt être géré au niveau du container ?
      return;
    }
    onCaseClick(rdv);
  };
  return (
    <div
      style={style}
      key={uniqueID}
      className={classNames(styles.case_rdv_empty, {
        [styles.topBar]: isZeroMinute(hmString),
      })}
      id={uniqueID}
      onClick={handleClick}
      data-testid={"RdvCaseEmpty"}
      ref={setNodeRef}
    >
      <div className={styles.hourDisplay}>
        {formaters.formatHourMinuteObjectForDisplay(rdv)}
      </div>
      <RdvStars stars={stars} />
    </div>
  );
};

export default EmptyCase;
